import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {sendQuery} from "../../../../../common/utils";
import {ExemptionBaseComponent} from "../../common/exemption_base/exemption_base.component";
import {
  Exemption_3_11,
  Vessel
} from '@portbase/bezoekschip-service-typescriptmodels';

@Component({
  selector: 'app-visit-exemptions-exemption-3-11',
  templateUrl: './exemption_3_11.component.html',
  styleUrls: ['./exemption_3_11.component.css'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class Exemption_3_11Component extends ExemptionBaseComponent {

  @Input() exemption: Exemption_3_11;

  THE_SHIP_IS_LONGER: string = 'The ship is wider or longer than the berth dimensions';
  MOORING_ALONGSIDE: string = 'Other vessels mooring alongside';
  OTHER = 'Other';

  secondVessel: Vessel;
  thirdVessel: Vessel;

  searchVessel = term => sendQuery('com.portbase.bezoekschip.common.api.visit.FindVessels', {term: term});
  reasonTypes: string[] = ['',
    this.THE_SHIP_IS_LONGER,
    this.MOORING_ALONGSIDE
  ];

  activityTypes: string[] = ['',
    'Ship-to-ship handling',
    this.OTHER
  ];

  otherVesselTypes: string[] = ['',
    'Floating crane',
    'Pontoon',
    this.OTHER
  ];

  secondVesselRequired(reasonType: string) {
    return this.THE_SHIP_IS_LONGER !== reasonType;
  }

  resetVesselInfoSecond() {
    this.secondVessel = null;
    this.exemption.secondVesselENI = '';
    this.exemption.secondVesselIMO = '';
    this.exemption.secondVesselNameENI = '';
    this.exemption.secondVesselNameIMO = '';
    this.exemption.secondVesselArrival = '';
    this.exemption.secondVesselDeparture = '';

    if (!this.exemption.secondVesselType) {
      this.exemption.thirdVesselType = '';
    }
  }

  resetVesselInfoThird() {
    this.thirdVessel = null;
    this.exemption.thirdVesselENI = '';
    this.exemption.thirdVesselIMO = '';
    this.exemption.thirdVesselNameENI = '';
    this.exemption.thirdVesselNameIMO = '';
    this.exemption.thirdVesselArrival = '';
    this.exemption.thirdVesselDeparture = '';
  }

  resetReasonType() {
    this.exemption.reasonTypeActivity = '';
    this.exemption.reasonTypeVessel = '';
  }

  resetActivityTypeDescription() {
    this.exemption.reasonTypeActivityDescription = '';
  }

  resetVesselTypeDescription() {
    this.exemption.reasonTypeVesselDescription = '';
  }
}
